/// <amd-module name="Analytics/Shared/Utils/Duration" />
import * as Resources from "Analytics/Shared/Utils/Resources";
import { format } from "VSS/Core/Util/String";

export function formatDuration(milliseconds: number) {
    const summarizedValue = { shortDuration: "", duration: "" };
    const seconds = milliseconds / 1000;
    if (seconds < 2) {
        summarizedValue.shortDuration = format(Resources.ShortDurationFormatForMilliSeconds, Math.round(milliseconds));
        summarizedValue.duration = format(Resources.DurationFormatForMilliSeconds, Math.round(milliseconds));
        return summarizedValue;
    }
    const minutes = seconds / 60;
    if (minutes < 2) {
        summarizedValue.shortDuration = format(Resources.ShortDurationFormatForSeconds, Math.round(seconds));
        summarizedValue.duration = format(Resources.DurationFormatForSeconds, Math.round(seconds));
        return summarizedValue;
    }
    const hours = minutes / 60;
    if (hours < 2) {
        summarizedValue.shortDuration = format(Resources.ShortDurationFormatForMinutes, Math.round(minutes));
        summarizedValue.duration = format(Resources.DurationFormatForMinutes, Math.round(minutes));
        return summarizedValue;
    }
    const days = hours / 24;
    if (days < 2) {
        summarizedValue.shortDuration = format(Resources.ShortDurationFormatForHours, Math.round(hours));
        summarizedValue.duration = format(Resources.DurationFormatForHours, Math.round(hours));
        return summarizedValue;
    }
    summarizedValue.shortDuration = format(Resources.ShortDurationFormatForDays, Math.round(days));
    summarizedValue.duration = format(Resources.DurationFormatForDays, Math.round(days));
    return summarizedValue;
}
